import { useEffect, useState } from "react";

export const STAGE_COLORS = {
  "To Do": { dot: "bg-blue-500", bar: "bg-blue-500", count: "bg-blue-100 text-blue-700 dark:bg-blue-950 dark:text-blue-300", accent: "border-l-blue-500" },
  "Prepare": { dot: "bg-violet-500", bar: "bg-violet-500", count: "bg-violet-100 text-violet-700 dark:bg-violet-950 dark:text-violet-300", accent: "border-l-violet-500" },
  "Create": { dot: "bg-teal-500", bar: "bg-teal-500", count: "bg-teal-100 text-teal-700 dark:bg-teal-950 dark:text-teal-300", accent: "border-l-teal-500" },
  "Review": { dot: "bg-orange-500", bar: "bg-orange-500", count: "bg-orange-100 text-orange-700 dark:bg-orange-950 dark:text-orange-300", accent: "border-l-orange-500" },
  "Approval": { dot: "bg-amber-500", bar: "bg-amber-500", count: "bg-amber-100 text-amber-700 dark:bg-amber-950 dark:text-amber-300", accent: "border-l-amber-500" },
  "Complete": { dot: "bg-emerald-500", bar: "bg-emerald-500", count: "bg-emerald-100 text-emerald-700 dark:bg-emerald-950 dark:text-emerald-300", accent: "border-l-emerald-500" },
};

export const STAGE_DESCRIPTIONS = {
  "To Do": "Work has been requested, assigned, and is waiting to be started.",
  "Prepare": "Get everything ready before creating — brief, content, photos, videos, references, script, information.",
  "Create": "Actual creative production — editing, designing, writing, producing, or developing the creative.",
  "Review": "Check the creative for quality, accuracy, brand alignment, requirements, and technical correctness.",
  "Approval": "Final approval is required before the creative can be completed.",
  "Complete": "The creative work has been fully completed, approved, and delivered or released as required.",
};

export const TIME_FIELDS = [
  ["preparation_time", "Preparation"],
  ["creation_time", "Creation"],
  ["review_time", "Review"],
  ["approval_time", "Approval"],
];

const STAGE_TO_FIELD = {
  Prepare: "preparation_time", Create: "creation_time", Review: "review_time", Approval: "approval_time",
};

export const PRIORITY_STYLES = {
  Low: "bg-slate-100 dark:bg-slate-800 text-slate-600 dark:text-slate-300",
  Medium: "bg-blue-100 dark:bg-blue-950 text-blue-700 dark:text-blue-300",
  High: "bg-amber-100 dark:bg-amber-950 text-amber-700 dark:text-amber-300",
  Urgent: "bg-rose-100 dark:bg-rose-950 text-rose-700 dark:text-rose-300",
};

function runningSeconds(asset) {
  if (!asset?.stage_started_at || asset?.archive_status !== "Active") return 0;
  const start = new Date(asset.stage_started_at).getTime();
  return Math.max(0, Math.floor((Date.now() - start) / 1000));
}

// Total time in the CURRENT stage (completed sessions in this stage + running)
export function liveStageSeconds(asset) {
  const field = STAGE_TO_FIELD[asset?.current_stage];
  const completed = field ? asset?.times?.[field] || 0 : 0;
  return completed + runningSeconds(asset);
}

// Grand total across tracked stages, including the running current stage
export function liveTotalSeconds(asset) {
  const base = asset?.times?.total_time || 0;
  const field = STAGE_TO_FIELD[asset?.current_stage];
  return base + (field ? runningSeconds(asset) : 0);
}

export function useNow(intervalMs = 1000) {
  const [now, setNow] = useState(Date.now());
  useEffect(() => {
    const i = setInterval(() => setNow(Date.now()), intervalMs);
    return () => clearInterval(i);
  }, [intervalMs]);
  return now;
}
